"use client";

import Script from "next/script";

interface FacebookPixelScriptProps {
  pixelId: string;
}

export default function FacebookPixelScript({
  pixelId,
}: FacebookPixelScriptProps) {
  return (
    <>
      <Script
        id="facebook-pixel-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)
            };
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('set', 'autoConfig', 'false', '${pixelId}');
            fbq('init', '${pixelId}');
            fbq('track', 'PageView');
          `,
        }}
      />

      {/* Fallback for blocked scripts */}
      <Script
        id="facebook-pixel-fallback"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            if (!window.fbq) {
              window.fbq = function() {
                console.log('FB Pixel blocked - event would be:', arguments);
              };
            }
          `,
        }}
      />
    </>
  );
}
